import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import gettextParser from 'gettext-parser';

const loadPoFile = async (language) => {
    try {
        const response = await fetch(`/locales/${language}.po`); // Ensure .po files are in /public/locales
        const poData = await response.text();
        const parsed = gettextParser.po.parse(poData);

        const translations = {};
        Object.entries(parsed.translations).forEach(([context, values]) => {
            Object.entries(values).forEach(([key, entry]) => {
                if (key) translations[key] = entry.msgstr[0];
            });
        });

        return translations;
    } catch (error) {
        console.error(`Error loading .po file for language ${language}:`, error);
        return {};
    }
};

i18n.use(initReactI18next).init({
    fallbackLng: 'en',
    debug: true,
    interpolation: { escapeValue: false },
    react: {
      useSuspense: true,
    },
  });

export const setLanguage = async (language) => {
    const translations = await loadPoFile(language);
    i18n.addResources(language, 'translation', translations);
    i18n.changeLanguage(language);
};

export default i18n;
